// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer__1cEeE","textLogo":"logo_textLogo__1G2yr"};